import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import BgTourist from "../../images/hotelTourist.png";
import Distance from "../../images/distance.svg";
import BackButton from "../bars/BackButton";
import PageSkeleton from "../../components/skeletons/PageSkeleton";
import Emty from "../../components/emty-state/Emty";
import { TouristGuidePageView } from "../../utils/Analytics";

function TouristGuide() {
  const location = useLocation();
  const menuVisibility = location.state?.menuVisibility || {};
  const [touristData, SetTouristData] = useState([]);
  const [hotelData, SethotelData] = useState([]);
  const currentUrl = window.location.href;
  const urlArray = currentUrl.split("/");
  const hotelId = urlArray[urlArray.length - 1];

  const [loading, setLoading] = useState(false);
  const [emty, setEmty] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);

    const getTourist = async () => {
      setLoading(true);
      try {
        await axios({
          method: "post",
          url: `${baseURL}/api/hotelGuideV21`,
          data: {
            hotelId: hotelId,
            type: "1",
          },

          headers: { "Content-Type": "application/json" },
        }).then(function (response) {
          SetTouristData(response.data.data);
          if (response.data.data.length === 0) {
            setEmty(true);
          }
          setLoading(false);

          // if (response.data.data.length == 0) {
          //     // console.log("hii");
          //     setAvailable(true);
          // }
          // SethotelData(response.data.data);
        });
      } catch {
        setLoading(false);
      }
    };
    getTourist();
  }, []);

   useEffect(() => {
      TouristGuidePageView();
     }, []);

  return (
    <div>
      {!loading ? (
        <div className="mb-28 relative">
          <div className="absolute top-3 left-3">
            <BackButton whiteTheme={true}/>
          </div>
          <img
            className="w-screen sm:h-[230px] h-[117px]"
            src={BgTourist}
            alt="bgHotelguide"
          />
          <div className="section-wrap mx-4 mt-6 sm:mt-14">
            <div className="guestName sm:text-center text-left">
              Nearest tourist places
            </div>
            <div className="gridTab grid grid-flow-row grid-cols-2 gap-3 gap-x-4 mt-3">
              {touristData.map((touristData, index) => (
                <Link
                  key={index}
                  to={"/tourist-place/" + touristData.id}
                  state={{ ...touristData, menuVisibility }}
                  className="flex flex-col p-2 w-full bg-[#342F4F] rounded-md  hover:shadow-lg  transition-all"
                >
                  <div className="w-full  flex justify-center items-stretch bg-gray-200 rounded-md overflow-hidden h-[106px] sm:h-[160px] ">
                    <img
                      width="100%"
                      height="100%"
                      className="flex items-stretch bg-contain object-cover transition w-full h-full"
                      src={touristData.image}
                      alt="hotelGuide"
                    ></img>
                  </div>
                  <div className="flex mt-2 sm:text-base text-[14px] font-medium pb-2">
                   <span className="truncate w-[auto] max-w-[180px]  sm:text-base text-[14px] font-medium">{touristData.name}</span>  
                  </div>
                  {touristData.distance && (
                    <div className="text-[#9A9A9A] font-medium text-[11px]  sm:text-center text-left mt-1 flex space-x-1">
                      <img src={Distance} alt="distance" />
                      <div>{touristData.distance} KM Away</div>
                    </div>
                  )}
                </Link>
              ))}
            </div>
          </div>
          {emty && <Emty item="Tourist  guide"/>}
        </div>
      ) : (
        <PageSkeleton type="page" />
      )}
    </div>
  );
}

export default TouristGuide;
